module.exports = __webpack_public_path__ + "static/edicaoPonto-44638c9e75d38b70f5aca9da3c82f5f2.gif";